var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.Root.Nodes),function(node){return _c('GenericNodeView',_vm._g({key:node.Id,attrs:{"Node":node}},_vm.$listeners))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }